export default __webpack_public_path__ + "static/media/about_bottom_dog.5e26852f.png";